import qs from "qs";

import { type QueryParams, type QueryString } from "./typed";

const queryStringify = (queryParams: QueryParams): QueryString => {
  return qs.stringify(queryParams, {
    // add prefix "?"
    addQueryPrefix: true,
    // set charset
    charset: "utf-8",
    // set array format
    arrayFormat: "comma",
    encodeValuesOnly: true,

    // other options
    skipNulls: true,
  }).replace(",", "+");
};

const queryParse = (queryString: QueryString): QueryParams => {
  return qs.parse(queryString.replace("+", ","), {
    // remove prefix "?"
    ignoreQueryPrefix: true,
    // set charset
    charset: "utf-8",
    // set array format
    comma: true,
    parseArrays: true,
  });
};

export {
  queryParse,
  queryStringify,
};
